// Auto-generated from spinner.spec.js
export default {
  "tagName": "ui-spinner",
  "content": [
    "text"
  ],
  "contentAttributes": [
    "text"
  ],
  "variations": [
    "size",
    "color",
    "block",
    "overlay"
  ],
  "states": [
    "active",
    "hidden"
  ],
  "attributes": [
    "text",
    "active",
    "hidden",
    "size",
    "color",
    "block",
    "overlay"
  ],
  "optionAttributes": {
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "slate": "color"
  },
  "propertyTypes": {
    "text": "string",
    "active": "boolean",
    "hidden": "boolean",
    "size": "string",
    "color": "string",
    "block": "boolean",
    "overlay": "boolean"
  },
  "allowedValues": {
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "slate"
    ]
  },
  "attributeClasses": [
    "color"
  ]
};
